import axios from 'axios';

export function getDiagnoses(patient_id) {
    return new Promise((resolve, reject) => {
        axios
            .get(`/api/diagnosticos/${patient_id}`)
            .then((response) => {
                resolve(response.data.data);
            })
            .catch((error) => {
                console.error('No se encontro datos de diagnósticos');
                reject(error);
            });
    });
}
